var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{attrs:{"id":"cardQ"}},[_c('div',{attrs:{"id":"question"}},[_vm._v("\n      "+_vm._s(_vm.testedWord.lemma.decenglish)+"\n    ")]),_c('quiz-answer',{attrs:{"answer":_vm.testedWord.lemma.decenglish,"propositions":_vm.randomWordsList},on:{"answer":_vm.relayAnswer}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }